document.addEventListener('DOMContentLoaded', function () {
  const params = new URLSearchParams(window.location.search);
  const name = params.get('name');

  if (name) {
    const elements = document.querySelectorAll('.quizUserName');

    elements.forEach(el => {
      el.innerText = name;
    });
  }
});